import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { injectAxnAttributeLabelId } from "@utils/parameter-injector";
import { AxnAttributeLabel, FormattedAxnAttributeLabel } from "@idw-types/data/reference-data/axn/axn-attribute-label";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

type UpdateAttributeLabelRequestResponse = {
    transferObject: AxnAttributeLabel;
};

export const updateAxnAttributeLabelRequest = async (
    axnAttributeLabel: FormattedAxnAttributeLabel
): Promise<GenericNetworkResponse<UpdateAttributeLabelRequestResponse>> => {
    const route = injectAxnAttributeLabelId(
        apiRoutes.axnadminCore.data.axnattributelabelWithId,
        axnAttributeLabel.id
    );

    const body = {
        label: axnAttributeLabel.label
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error, body };
};